import { render, staticRenderFns } from "./file-parse-uploads.vue?vue&type=template&id=1bc77108&scoped=true&"
import script from "./file-parse-uploads.vue?vue&type=script&lang=ts&"
export * from "./file-parse-uploads.vue?vue&type=script&lang=ts&"
import style0 from "./file-parse-uploads.vue?vue&type=style&index=0&id=1bc77108&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc77108",
  null
  
)

export default component.exports